import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
    { path: '/', emoji: '🏠', label: 'Home' },
    { path: '/services', emoji: '📋', label: 'Services' },
    { path: '/events', emoji: '🎟', label: 'Events' },
    { path: '/flights', emoji: '✈️', label: 'Flights' },
    { path: '/bookings', emoji: '📂', label: 'My Bookings' },
];

export default function Layout({ children }) {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: 560,
            margin: '0 auto', position: 'relative'
        }}>
            {/* Content */}
            <div style={{ flex: 1, overflowY: 'auto', paddingBottom: 76 }}>
                {children}
            </div>

            {/* Bottom nav */}
            <nav style={{
                position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
                width: '100%', maxWidth: 560, backgroundColor: 'var(--bg-card)',
                borderTop: '1px solid var(--border)', display: 'flex',
                height: 68, zIndex: 100,
            }}>
                {TABS.map(tab => {
                    const active = location.pathname === tab.path ||
                        (tab.path !== '/' && location.pathname.startsWith(tab.path));
                    return (
                        <button key={tab.path} onClick={() => navigate(tab.path)} style={{
                            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
                            justifyContent: 'center', gap: 2, background: 'none', border: 'none',
                            cursor: 'pointer', padding: '4px 0 8px',
                        }}>
                            <span style={{ fontSize: 22, opacity: active ? 1 : 0.5 }}>{tab.emoji}</span>
                            <span style={{
                                fontSize: 11, fontWeight: 600,
                                color: active ? 'var(--brand-300)' : 'rgba(74,222,128,0.4)',
                            }}>{tab.label}</span>
                        </button>
                    );
                })}
            </nav>
        </div>
    );
}
